/**
 * Document Library — Storefront
 * Fetches data from Airtable (public read token)
 * Renders libraries via data-dl-render or [doclibrary] shortcode
 *
 * Config injected by Liquid in theme.liquid:
 *   window.DL_CONFIG = { airtableToken: 'patXXX', airtableBase: 'appXXX' };
 */

(function () {
  'use strict';

  const AIRTABLE_API = 'https://api.airtable.com/v0';
  let _cache = null;

  function cfg() { return window.DL_CONFIG || {}; }

  // ─── Fetch & normalise from Airtable ─────────────────────────────────────────

  async function getData() {
    if (_cache) return _cache;
    try {
      const base  = cfg().airtableBase;
      const token = cfg().airtableToken;
      if (!base || !token) {
        console.warn('DocLibrary: Missing DL_CONFIG');
        return { documents: [], libraries: [] };
      }
      const headers = { Authorization: 'Bearer ' + token };
      async function fetchAll(table) {
  var records = [];
  var offset  = null;
  do {
    var url  = AIRTABLE_API + '/' + base + '/' + table + '?pageSize=100' + (offset ? '&offset=' + offset : '');
    var resp = await fetch(url, { headers: headers });
    if (!resp.ok) throw new Error(table + ' fetch failed: ' + resp.status);
    var json = await resp.json();
    records  = records.concat(json.records || []);
    offset   = json.offset || null;
  } while (offset);
  return { records: records };
}

const docsJson = await fetchAll('Documents');
const libsJson = await fetchAll('Libraries');

      const documents = (docsJson.records || []).map(function(r) {
        return {
          id:       r.id,
          title:    r.fields.title    || r.fields.Title    || 'Untitled',
          category: r.fields.category || r.fields.Category || '',
          section:  r.fields.section  || r.fields.Section  || '',
          type:     r.fields.type     || r.fields.Type     || 'auto',
          url:      r.fields.url      || r.fields.URL      || '',
          visible:  r.fields.visible  !== false && r.fields.Visible !== false,
        };
      });

      const libraries = (libsJson.records || []).map(function(r) {
        return {
          id:          r.fields.id          || r.fields.ID          || r.id,
          name:        r.fields.name        || r.fields.Name        || 'Unnamed',
          description: r.fields.description || r.fields.Description || '',
          docIds:      r.fields.documents   || r.fields.Documents   || [],
        };
      });

      _cache = { documents: documents, libraries: libraries };
      return _cache;
    } catch(e) {
      console.error('DocLibrary: fetch error', e);
      return { documents: [], libraries: [] };
    }
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────────

  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2,6); }

  function fileType(url, override) {
    if (override && override !== 'auto') return override;
    if (!url) return 'file';
    var m = url.split('?')[0].match(/\.([a-z0-9]+)$/i);
    var e = m ? m[1].toLowerCase() : '';
    if (e === 'pdf') return 'pdf';
    if (['doc','docx'].indexOf(e) > -1) return 'doc';
    if (['xls','xlsx','csv'].indexOf(e) > -1) return 'xls';
    if (['jpg','jpeg','png','gif','webp','svg','avif'].indexOf(e) > -1) return 'img';
    if (['zip','gz','tar'].indexOf(e) > -1) return 'zip';
    if (['mp4','mov','avi','webm'].indexOf(e) > -1) return 'video';
    return 'file';
  }

  function docIcon(color, label) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">'
      + '<path d="M6 2h9l5 5v15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z" fill="' + color + '" opacity=".15"/>'
      + '<path d="M15 2l5 5h-5V2z" fill="' + color + '"/>'
      + '<text x="7" y="19" font-size="5.5" fill="' + color + '" font-family="system-ui,sans-serif" font-weight="700">' + label + '</text>'
      + '</svg>';
  }

  function iconIMG() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">'
      + '<rect x="2" y="3" width="20" height="18" rx="2" fill="#0D9488" opacity=".15"/>'
      + '<rect x="2" y="3" width="20" height="18" rx="2" stroke="#0D9488" stroke-width="1.5" fill="none"/>'
      + '<circle cx="8" cy="9" r="2" fill="#0D9488" opacity=".6"/>'
      + '<path d="M2 15l5-5 4 4 3-3 6 6H2z" fill="#0D9488" opacity=".4"/>'
      + '</svg>';
  }

  var TYPE_META = {
    pdf:   { label:'PDF',   color:'#ED3823', bg:'#ed372337', icon: docIcon('#ED3823','PDF') },
    doc:   { label:'DOC',   color:'#1D4ED8', bg:'#DBEAFE', icon: docIcon('#1D4ED8','DOC') },
    xls:   { label:'XLS',   color:'#16A34A', bg:'#DCFCE7', icon: docIcon('#16A34A','XLS') },
    img:   { label:'IMG',   color:'#006072', bg:'#00617236', icon: iconIMG() },
    zip:   { label:'ZIP',   color:'#004F42', bg:'#004f4221', icon: docIcon('#004F42','ZIP') },
    video: { label:'VIDEO', color:'#EA580C', bg:'#FFEDD5', icon: docIcon('#EA580C','VID') },
    file:  { label:'FILE',  color:'#64748B', bg:'#F1F5F9', icon: docIcon('#94A3B8','FILE') },
  };

  var CAT_PALETTE = [
    {bg:'#00617236',text:'#006072'},{bg:'#312b262b',text:'#312B26'},
    {bg:'#ed372337',text:'#ED3823'},{bg:'#00617236',text:'#006072'},
    {bg:'#FFFBEB',text:'#B45309'},{bg:'#ed372337',text:'#ED3823'},
    {bg:'#f7dccd34',text:'#F7DCCD'},{bg:'#F8FAFC',text:'#475569'},
  ];
  var catColorCache = {};
  var catColorIdx   = 0;

  function catColor(cat) {
    if (!catColorCache[cat]) { catColorCache[cat] = CAT_PALETTE[catColorIdx++ % CAT_PALETTE.length]; }
    return catColorCache[cat];
  }

  function esc(str) {
    return String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ─── Renderer ─────────────────────────────────────────────────────────────────

  var PER_PAGE = 12;

  // Store per-container pagination state
  var _pageState = {};

  async function renderLibrary(containerId, libraryId, options) {
    options = options || {};
    var container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = '<div class="dl-loading" style="padding:2rem;text-align:center;color:#9CA3AF;font-size:0.875rem">Loading\u2026</div>';

    var data    = await getData();
    var library = null;
    for (var i = 0; i < data.libraries.length; i++) {
      if (data.libraries[i].id === libraryId) { library = data.libraries[i]; break; }
    }

    if (!library) {
      container.innerHTML = '<p class="dl-error">Document library &ldquo;' + esc(libraryId) + '&rdquo; not found.</p>';
      return;
    }

    var allDocs = (library.docIds || []).map(function(id) {
      for (var j = 0; j < data.documents.length; j++) {
        if (data.documents[j].id === id) return data.documents[j];
      }
      return null;
    }).filter(function(d) { return d && d.visible; });

    // Initialise page state for this container
    if (!_pageState[containerId]) _pageState[containerId] = { page: 1, filter: 'All' };

    // Store docs so DLPag can re-render without re-fetching
    if (window.DocLibrary) window.DocLibrary._allDocs[containerId] = allDocs;

    var showTitle    = options.showTitle    !== false;
    var showFilters  = options.showFilters  !== false;

    var cats = ['All'];
    allDocs.forEach(function(d) { if (d.category && cats.indexOf(d.category) === -1) cats.push(d.category); });

    // Build outer shell once
    var html = '<div class="dl-library">';

    if (showTitle) {
      html += '<div class="dl-header"><h2 class="dl-title">' + esc(library.name) + '</h2>';
      if (library.description) html += '<p class="dl-description">' + esc(library.description) + '</p>';
      html += '</div>';
    }

html += '<div class="dl-toolbar">';
    if (showFilters && cats.length > 2) {
      html += '<div class="dl-filters" role="group">';
      cats.forEach(function(c) {
        html += '<button class="dl-filter-btn' + (c === _pageState[containerId].filter ? ' active' : '') + '" data-cat="' + esc(c) + '">' + esc(c) + '</button>';
      });
      html += '</div>';
    } else {
      html += '<div></div>';
    }
    html += '<div class="dl-search-wrap">'
      + '<svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" stroke-width="1.5"/><path d="M10.5 10.5l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
      + '<input class="dl-search-input" type="search" placeholder="Search documents\u2026" id="' + containerId + '-search">'
      + '</div>';
    html += '</div>';

    html += '<div id="' + containerId + '-grid" class="dl-grid-wrap"></div>';
    html += '<div id="' + containerId + '-pagination" class="dl-pagination"></div>';
    html += '</div>';

    container.innerHTML = html;

// Bind filter buttons
    container.querySelectorAll('.dl-filter-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        _pageState[containerId].filter = btn.dataset.cat;
        _pageState[containerId].page   = 1;
        _pageState[containerId].search = '';
        var si = document.getElementById(containerId + '-search');
        if (si) si.value = '';
        container.querySelectorAll('.dl-filter-btn').forEach(function(b){
          b.classList.toggle('active', b.dataset.cat === btn.dataset.cat);
        });
        renderPage(containerId, allDocs);
      });
    });

    // Bind search
    var searchInput = document.getElementById(containerId + '-search');
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        _pageState[containerId].search = this.value.toLowerCase();
        _pageState[containerId].page   = 1;
        renderPage(containerId, allDocs);
      });
    }

    renderPage(containerId, allDocs);
  }

  function renderPage(containerId, allDocs) {
    var ps      = _pageState[containerId];
    var filter  = ps.filter || 'All';
    var page    = ps.page   || 1;

var search   = (ps.search || '').toLowerCase();
    var filtered = allDocs.filter(function(d){
      var catMatch    = filter === 'All' || d.category === filter;
      var searchMatch = !search || d.title.toLowerCase().indexOf(search) > -1;
      return catMatch && searchMatch;
    });
        var total    = filtered.length;
    var pages    = Math.ceil(total / PER_PAGE);
    if (page > pages) page = ps.page = 1;

    var start    = (page - 1) * PER_PAGE;
    var pageDocs = filtered.slice(start, start + PER_PAGE);

    // Render cards
    var gridEl = document.getElementById(containerId + '-grid');
    if (gridEl) {
      if (pageDocs.length === 0) {
        gridEl.innerHTML = '<div class="dl-empty">No documents found.</div>';
      } else {
        var gridHtml = '<div class="dl-grid">';
        pageDocs.forEach(function(d){ gridHtml += renderDocCard(d); });
        gridHtml += '</div>';
        gridEl.innerHTML = gridHtml;
      }
    }

    // Render pagination
    var pagEl = document.getElementById(containerId + '-pagination');
    if (pagEl) {
      if (pages <= 1) { pagEl.innerHTML = ''; return; }

      var phtml = '<div class="dl-pag">';

      // Prev button
      phtml += '<button class="dl-pag-btn dl-pag-prev" ' + (page <= 1 ? 'disabled' : '') + ' onclick="DLPag(\'' + containerId + '\',' + (page-1) + ')">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>';

      // Page numbers — show max 7 buttons with ellipsis
      var pageNums = buildPageNums(page, pages);
      pageNums.forEach(function(p) {
        if (p === '...') {
          phtml += '<span class="dl-pag-ellipsis">&hellip;</span>';
        } else {
          phtml += '<button class="dl-pag-btn' + (p === page ? ' active' : '') + '" onclick="DLPag(\'' + containerId + '\',' + p + ')">' + p + '</button>';
        }
      });

      // Next button
      phtml += '<button class="dl-pag-btn dl-pag-next" ' + (page >= pages ? 'disabled' : '') + ' onclick="DLPag(\'' + containerId + '\',' + (page+1) + ')">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 2l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>';

      // Count
      var from = start + 1;
      var to   = Math.min(start + PER_PAGE, total);
      phtml += '<span class="dl-pag-count">' + from + '&ndash;' + to + ' of ' + total + '</span>';

      phtml += '</div>';
      pagEl.innerHTML = phtml;
    }
  }

  function buildPageNums(current, total) {
    if (total <= 7) {
      var arr = [];
      for (var i = 1; i <= total; i++) arr.push(i);
      return arr;
    }
    var pages = [1];
    if (current > 3) pages.push('...');
    for (var p = Math.max(2, current-1); p <= Math.min(total-1, current+1); p++) pages.push(p);
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  // Global pagination handler — called by inline onclick
  window.DLPag = function(containerId, page) {
    if (!_pageState[containerId]) return;
    _pageState[containerId].page = page;
    // Re-fetch allDocs from cache and re-render page
    if (window.DocLibrary && window.DocLibrary._allDocs && window.DocLibrary._allDocs[containerId]) {
      renderPage(containerId, window.DocLibrary._allDocs[containerId]);
      // Scroll to top of library
      var el = document.getElementById(containerId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  function renderDocCard(doc) {
    var type = fileType(doc.url, doc.type);
    var meta = TYPE_META[type] || TYPE_META.file;
    var cc   = catColor(doc.category || 'General');
    var tag  = doc.url ? 'a' : 'div';
    var attrs = tag === 'a' ? 'href="' + esc(doc.url) + '" target="_blank" rel="noopener"' : '';
    return '<' + tag + ' class="dl-doc-card" ' + attrs + ' data-category="' + esc(doc.category||'') + '" data-type="' + type + '">'
      + '<div class="dl-doc-icon" style="background:' + meta.bg + '">' + meta.icon + '</div>'
      + '<div class="dl-doc-body">'
      + '<div class="dl-doc-name">' + esc(doc.title) + '</div>'
      + '<div class="dl-doc-meta">'
      + '<span class="dl-cat-badge" style="background:' + cc.bg + ';color:' + cc.text + '">' + esc(doc.category||'General') + '</span>'
      + '<span class="dl-type-badge" style="color:' + meta.color + '">' + meta.label + '</span>'
      + '</div></div>'
      + '<div class="dl-doc-arrow"><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
      + '</' + tag + '>';
  }

  // ─── Shortcode Parser ─────────────────────────────────────────────────────────

  function parseShortcodes() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var matches = [];
    var node;
    while ((node = walker.nextNode())) {
      if (/\[doclibrary\b[^\]]*\]/.test(node.textContent)) matches.push(node);
    }
    matches.forEach(function(textNode) {
      var parent = textNode.parentNode;
      var html = textNode.textContent.replace(/\[doclibrary\b([^\]]*)\]/g, function(_, attrStr) {
        var attrs = parseAttrs(attrStr);
        if (!attrs.id) return '<span class="dl-error">doclibrary shortcode missing id</span>';
        var cid = 'dl-sc-' + uid();
        setTimeout(function() {
          renderLibrary(cid, attrs.id, {
            showTitle:       attrs.show_title    !== 'false',
            showFilters:     attrs.show_filters  !== 'false',
            groupBySections: attrs.group_sections !== 'false',
          });
        }, 0);
        return '<div id="' + cid + '" class="dl-shortcode-container"></div>';
      });
      var wrapper = document.createElement('span');
      wrapper.innerHTML = html;
      parent.replaceChild(wrapper, textNode);
    });
  }

  function parseAttrs(str) {
    var attrs = {};
    var re = /(\w+)=["']([^"']*)["']/g;
    var m;
    while ((m = re.exec(str))) attrs[m[1]] = m[2];
    return attrs;
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────

  function init() {
    document.querySelectorAll('[data-dl-render]').forEach(function(el) {
      renderLibrary(el.id, el.dataset.dlRender, {
        showTitle:       el.dataset.dlTitle    !== 'false',
        showFilters:     el.dataset.dlFilters  !== 'false',
        groupBySections: el.dataset.dlSections !== 'false',
      });
    });
    parseShortcodes();
  }

  window.DocLibrary = { getData: getData, render: renderLibrary, init: init, _allDocs: {} };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();